/**
 * 详情页附件信息展示
 * 
 */
'use strict';
angular
    .module('editPageAppendixUploadModule')
    .directive('appendixPreview', ['trsFileService', function(trsFileService){
        return {
            scope: {
                files: '='
            },
            restrict: 'EA',
            templateUrl: './editingCenter/directive/editPagePart/editPageAppendixUpload/appendixPreview/appendixPreview_tpl.html',
            replace: true,
            link: function(scope) {
                scope.getFileIcon = function(fileDesc){
                    return trsFileService.getFileIconImg(fileDesc).replace('./', 'https://authorized.trscd.com.cn/');
                };

                scope.getAttachId = function(fileDesc, src) {
                    return trsFileService.getUniqueId(fileDesc + src);
                };
            }
        };
    }]);
